// @flow
import React, { Component } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";

import Preloader from '../Preloader';
import { isAuthenticated } from '../../utils/auth';
import { replaceUrlTo } from '../../utils/url';
import LocalStorage from '../../utils/storage/LocalStorage';

import * as selectors from "../../modules/selectors";

type Props = {
	component: Object,
	is_authenticated: boolean,
	has_user: boolean
};

type State = {
	user_requested_url?: string
}

const mapStateToProps = state => ({
	is_authenticated: isAuthenticated(),
	has_user: selectors.hasUser(state)
});

class PrivateRouteContainer extends Component<Props, State> {
	componentDidMount() {
		const { is_authenticated } = this.props;

		if (!is_authenticated) {
			LocalStorage.set(
				'user_requested_route_before_auth',
				window.location.pathname
			);
			replaceUrlTo(window.location.origin + '/draft/');
		}
	}

	render() {
		const {
			component: Component,
			is_authenticated,
			has_user,
			...rest
		} = this.props;

		return (
			<Route {...rest} render={(props: Object) => (
				is_authenticated ? <Component {...props} /> : <Preloader />
			)} />
		);
	}
}

export const PrivateRoute = connect(mapStateToProps)(PrivateRouteContainer);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js